// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './stores';
import ElementUI from 'element-ui';

Vue.prototype.$http = axios
Vue.use(ElementUI);
var reqUrl = 'http://'+window.location.host+'/';//'//eton.gzairnest.com/';//
Vue.prototype.$reqUrl = reqUrl;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js